
import axios from 'axios'
import { url } from './url'
import queryStringUtil from "query-string";

function getConnectionLogs(gatewayId) {
    var urlString = `${url}/gateway/${gatewayId}/connectionLogs`;
    return axios
        .get(urlString)
        .then(res => {
            return res.data
        });
}
function queryString(query) {
    var queryParams = {
        ...query
    };
    return queryStringUtil.stringify(queryParams, {
        arrayFormat: "bracket"
    });
}

function newCertGateway(id) {
    return axios.put(`${url}/gateway/${id}/newcert`)
        .then(resp => {
            return resp.data
        })
}

function getGateways(query) {
    var urlString = `${url}/gateway?${queryString(query)}`;
    return axios
        .get(urlString)
        .then(res => {
            return {
                total: res.data.total,
                gateways: res.data.gateways
            }
        });
}

function getGatewayFirmwares(query) {
    return axios.get(`${url}/hardwares/firmwares?${queryString(query)}`)
        .then(resp => {
            return resp.data
        })
}

function getGatewayVersion(query) {
    return axios.get(`${url}/hardwares/version?${queryString(query)}`)
        .then(resp => {
            return resp.data
        })
}

function updateGatewayFirmwares(query) {
    return axios.put(`${url}/gateway/${query._id}/ota`, query)
        .then(resp => {
            return resp.data
        })
}

function createGateway(gateway) {
    return axios.post(`${url}/gateway`, gateway)
        .then(resp => {
            return resp.data
        })
}
function deleteGateway(id) {
    return axios.delete(`${url}/gateway/${id}`)
        .then(resp => {
            return resp.data
        })
}
function updateGateway(gateway) {
    return axios.put(`${url}/gateway/${gateway._id}`, gateway)
        .then(resp => {
            return resp.data
        })
}
export default {
    getGateways,
    createGateway,
    deleteGateway,
    getConnectionLogs,
    updateGateway,
    newCertGateway,
    getGatewayFirmwares,
    updateGatewayFirmwares,
    getGatewayVersion
};